import { render, staticRenderFns } from "./AgregarCliente.vue?vue&type=template&id=6c01d74f&scoped=true"
import script from "./AgregarCliente.vue?vue&type=script&lang=js"
export * from "./AgregarCliente.vue?vue&type=script&lang=js"
import style0 from "./AgregarCliente.vue?vue&type=style&index=0&id=6c01d74f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01d74f",
  null
  
)

export default component.exports